import { Tab, Nav } from "react-bootstrap";
import "./vendor-order.scss";
import ColorSchema from "../../../assets/kits/colors";
import { useState } from "react";

import VendorOrdersItem from "./VendorOrdersItem";
import OrderDetailDrawer from "./OrderDetailDrawer";

export default function OrderTabs() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <>
      {" "}
      <Tab.Container
        id="vendor-order-tabs"
        className="vendor-order-tabs"
        defaultActiveKey={"new"}
      >
        <div
          className="tab-header mr-b-16 d-flex align-items-center"
          style={{
            borderRadius: 6,
            height: 45,
            backgroundColor: ColorSchema.gray_0,
            color: ColorSchema.gray_900,
          }}
        >
          <Nav.Item className="flex-grow-1 text-center">
            <Nav.Link
              eventKey="new"
              className={`mr-4 title-h5-m d-flex align-items-center justify-content-center ${"active-tab"}`}
              style={{ height: 37 }}
            >
              <div
                className="rounded-pill desc-m mr-l-4"
                style={{
                  width: 16,
                  height: 16,
                  color: ColorSchema.white_0,
                  backgroundColor: ColorSchema.red_600,
                }}
              >
                4
              </div>
              جدید
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="flex-grow-1 text-center">
            <Nav.Link
              eventKey="old"
              className="mr-4 title-h5-m d-flex align-items-center justify-content-center"
              style={{ height: 37 }}
            >
              بررسی شده{" "}
            </Nav.Link>
          </Nav.Item>
        </div>
        <Tab.Content>
          <Tab.Pane eventKey={"new"}>
            <VendorOrdersItem
              status={1}
              onClickFunc={() => setDrawerOpen(true)}
            />
          </Tab.Pane>
          <Tab.Pane eventKey={"old"}>
            <VendorOrdersItem
              status={0}
              onClickFunc={() => setDrawerOpen(true)}
            />

            <VendorOrdersItem
              status={2}
              onClickFunc={() => setDrawerOpen(true)}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
      <OrderDetailDrawer
        isOpen={drawerOpen}
        setIsOpen={setDrawerOpen}
        height={260}
      />
    </>
  );
}
